import {
  // ChevronUp,
  Trash2,
  Edit,
  // PlusCircle,
  // RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { useLocation, useNavigate } from "react-router-dom";

// import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
// import { useCheckUserPermission } from "../../common/userPermission";
import HeaderModule from "../../components/Header/HeaderModule";

const Category = () => {
  // const location = useLocation();
  // const parts = location.pathname;
  // let pathname = parts?.trim()?.split("/");
  // const dispatch = useDispatch();
  // const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const ID = localStorage.getItem("ID");
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (ID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(ID);
        MySwal.fire({
          title: "Deleted!",
          text: "Your category has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleDelete = async (id) => {
    console.log(id, "delete");

    let reqobj = {
      ID: id,
      loginUser: ID,
    };
    const response = await apiHandler({
      method: "POST",
      route: "Business/categoryDelete",
      payload: reqobj,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      // showConfirmationAlert();
      setdelete(!deletes);
    } else {
      console.log(response, "data");
    }
  };
  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      sortingFn: "numeric",
      size : 120
    },
    {
      header: "Business Name",
      accessorKey: "businessName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Service Menu",
      accessorKey: "categoryName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    // {
    //   header: "Service Menu Description",
    //   accessorKey: "categoryDescription",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    //   size: 320,
    //   Cell: ({ cell }) => (
    //     <div
    //       style={{
    //         display: "-webkit-box",
    //         WebkitLineClamp: 2,
    //         WebkitBoxOrient: "vertical",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         whiteSpace: "normal",
    //         maxWidth: "100%"
    //       }}
    //       title={cell.getValue()} // Show full text on hover
    //     >
    //       {cell.getValue()}
    //     </div>
    //   )
    // },
    // {
    //   header: " Parent Service Menu",
    //   accessorKey: "ParentCatName",
    //   enableSorting: true,
    //   sortingFn: "alphanumeric",
    // },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
            className="btn btn-outline-primary btn-sm me-2"
            onClick={() => {
              navigate(`${route.AddCategorys}/${row.original.ID}`);
              console.log("Edit row:", row.original.ID);
            }}
          >
            <Edit className="custome-icon-size"/>
          </button>
          <button
 className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              
              showConfirmationAlert(row.original.ID)
            }}
          >
            <Trash2 className="custome-icon-size"/>
          </button>
        </Box>
      ),
    },
  ];

  // console.log(productlist, "productlist p");
  // console.log(columns, "productlist c");

  const route = all_routes;

  // const renderTooltip = (props) => (
  //   <Tooltip id="pdf-tooltip" {...props}>
  //     Pdf
  //   </Tooltip>
  // );
  // const renderExcelTooltip = (props) => (
  //   <Tooltip id="excel-tooltip" {...props}>
  //     Excel
  //   </Tooltip>
  // );
  // const renderPrinterTooltip = (props) => (
  //   <Tooltip id="printer-tooltip" {...props}>
  //     Printer
  //   </Tooltip>
  // );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );
  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryAll?businessId=${userData?.businessId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    // ID: item?.ID,
    Name: item?.Name,
    ParentCatName: item?.ParentCatName,
    businessName: item?.businessName
  }));

  console.log(productlist, "productlist123")
  // console.log(setToogleHeader(!data), "setToogleHeader(!data)")

  return (
    <div className="page-wrapper">
      <div className="content">
        
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.AddCategorys}
        />
       
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default Category;
